import $ from 'jquery';
import ScrollMagic from 'scrollmagic';
import 'slick-carousel';
import Util from '../utils/ui';
import * as CONST from '../utils/constants';
import analytics from '../utils/analytics';

class Search {
	constructor() {
	}

	init() {
		this.bindEvents();
	}

	bindEvents() {	
		$('.expand-facet').click((e) => {
			jQuery(e.target).toggleClass('collapsed');
			let collapsable = jQuery(e.target).parent().children()[2];
			jQuery(collapsable).slideToggle();
		});
	}
}

export default Search;